module.exports = function previewSample(sample) {
  if (sample) {
    sample.file.loop = false
    sample.file.stop()
    sample.file.start(0)
  }
}
